module.exports = __webpack_public_path__ + "static/media/icn-arrow-long.067973d7.svg";